import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectSiteUrl, selectPageId } from 'core/selectors/app';
import { getParamsFromSearch } from 'core/utils/helpers/getParamsFromSearch';
import { encodeQueryString } from 'core/utils/helpers/url';

import './SearchProductsLink.scss';

function SearchProductsLink({ sid, className, text }) {
  const location = useLocation();
  const siteUrl = useSelector(selectSiteUrl);
  const pageId = useSelector(selectPageId);
  const { keywords, mnpos } = getParamsFromSearch(location.search);
  const queryString = encodeQueryString({
    keywords, page_id: pageId, sid, mnpos,
  });

  return (
    <div className="mn_searchProductsLinkWrap">
      <a className={`mn_searchMerchantProductsLink ${className}`} href={`${siteUrl}/sr____.htm?${queryString}`}>
        {text || `Search products for "${keywords}"` }
      </a>
    </div>
  );
}

SearchProductsLink.propTypes = {
  sid: PropTypes.number.isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
};

SearchProductsLink.defaultProps = {
  className: '',
  text: '',
};

export default SearchProductsLink;
